import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DocketParts from '../docket/docketEntries/Documents';
import HistoryEntriesTableBody from './HistoryEntriesTableBody';
import { ProgressBar } from 'react-bootstrap';

const HistoryEntries = (props) => {
  const {
    history,
    getDocketDetails,
    case_uuid,
    court_code,
    case_number,
    selectedDocketDetailNum,
    sortHistory,
    entries,
    tableSortProps,
    selectedDocket,
  } = props;

  const { docketDetails = {} } = history;
  const getClassName = index => (index % 2 === 0 ? 'even' : 'odd');
  const sortIconsFA = {
    'asc': 'fa-sort-up',
    'desc': 'fa-sort-down',
  };
  let itemRows = null;

  if (_.isEmpty(entries)) {
    itemRows = <tr><td colSpan="4"> No History/Documents Found</td></tr>;
  } else {
    itemRows = entries.reduce((accum, p, idx) => {
      const { text, meta } = p;

      const key = `history-entry-${text.docket_seq}`;
      const visibilityClass = p.isVisible ? '' : 'hide-history-entry-row';


      const colorClasses = {
        0: 'in-pacer',
        1: 'in-inforuptcy',
        2: 'purchased',
      };

      const docketNumLink = (!text.docket_uri)
        ? (text.docket_no || null)
        : (
          <div className={`view_details ${colorClasses[meta.purchased || 0]}`}
               dataDocketSeq={text.docket_seq}
               href=""
               onClick={() => getDocketDetails(text)}>
            <strong> {text.docket_no || "doc"} </strong>
          </div>
        );

      accum.push((
        <tr key={key} className={`${getClassName(idx)} docket_details ${visibilityClass}`}>
          <td style={{ textAlign: 'center', paddingLeft: 25 }} colSpan="2">
            { docketNumLink }
          </td>
          <td style={{ paddingLeft: 15 }}>
            <span dangerouslySetInnerHTML={{ __html: text.docket_text }} />
          </td>
          <td style={{ textAlign: 'center' }} >{text.date_filed}</td>
          <td style={{ textAlign: 'center' }} >{text.date_terminated}</td>
        </tr>
      ));


      if (selectedDocket.docket_seq === text.docket_seq) {
        if (selectedDocket.status === 'loading')
          accum.push((
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details`}>
              <td colSpan="2" />
              <td style={{paddingTop: '26px'}}>
                <ProgressBar active now={100} />
              </td>
              <td colSpan="100%"/>
            </tr>
          ))

        else if (selectedDocket.binder.documents && selectedDocket.binder.documents.length === 0)
          accum.push((
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details`}>
              <td colSpan="2" />
              <td className="here" colSpan="100%">No Accessible Documents Found</td>
            </tr>
          ));

        else if (selectedDocket.binder.documents && selectedDocket.binder.documents.length > 0)
          accum.push((
            <tr key={`details-${key}`} className={`${getClassName(idx)} docket_details ${visibilityClass}`}>
              <td colSpan="2" />
              <td className="here" colSpan="100%">
                <table className="sticky-enabled">
                  <thead>
                    <tr>
                      <th />
                      <th>Part</th>
                      <th>Description</th>
                      <th>Pages</th>
                      <th width="50%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <DocketParts
                      documents={selectedDocket.binder.documents}
                      case_uuid={case_uuid}
                      court_code={court_code}
                      case_number={case_number}
                      docket_seq={selectedDocket.docket_seq}
                    />
                  </tbody>
                </table>
              </td>
            </tr>
          ));

      }


      return accum;
    }, []);
  }

  return (
    <div id="ir-search-history-results">
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: 'center', minWidth: '20px' }} colSpan="2">
              <div className="item" onClick={sortHistory.bind(null, 'docket_no')}>#
                {tableSortProps.sort_field === 'docket_no' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
            <th style={{ whiteSpace: 'nowrap', paddingLeft: 15 }}>
              <div className="item" onClick={sortHistory.bind(null, 'docket_text')}>Description
                {tableSortProps.sort_field === 'docket_text' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
            <th style={{ textAlign: 'center', minWidth: '115px' }} >
              <div className="item" onClick={sortHistory.bind(null, 'date_filed')}>Date Filed/Entered
                {tableSortProps.sort_field === 'date_filed' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
            <th style={{ textAlign: 'center', minWidth: '115px' }}>
              <div className="item" onClick={sortHistory.bind(null, 'date_terminated')}>Date Terminated
              {tableSortProps.sort_field === 'date_terminated' ? <i className={`fa ${sortIconsFA[tableSortProps.sort_direction]}`} /> : ''}
              </div>
            </th>
          </tr>
        </thead>
        <HistoryEntriesTableBody rows={itemRows} keywords={props.keyword} />
      </table>
    </div>
  );
};

HistoryEntries.defaultProps = {
  selectedDocketDetailNum: null,
  redactSeqNum: null,
};

HistoryEntries.propTypes = {
  entries: PropTypes.array.isRequired,
  history: PropTypes.any.isRequired,
  getDocketDetails: PropTypes.any.isRequired,
  tableSortProps: PropTypes.any.isRequired,
  case_uuid: PropTypes.any.isRequired,
  sortHistory: PropTypes.any.isRequired,
  selectedDocketDetailNum: PropTypes.string,
  redactSeqNum: PropTypes.any,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
};

export default HistoryEntries;



// WEBPACK FOOTER //
// ./src/components/case/history/HistoryEntries.jsx